// Per-store acquisition tracking (WEB-Q11, Design B - Lily 2026-09-02):
// the in-store Get Started posters carry per-store short URLs
// (luckyclaww.com/bellevue, /kent) that all render the ONE intro page.
// The store from the URL is remembered in localStorage so it can ride
// along to the acquisition-survey write on the dashboard, which is the
// single place user_acquisition_sources docs are created.
//
// The memory expires after 24 hours (same-day-visit semantics): someone
// who scanned a poster but signs up organically weeks later should be
// "store unknown", not a stale guess. Unknown is always written as null -
// never inferred.

const KEY = 'acquisitionStore';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const KNOWN_STORES = ['bellevue', 'kent'];

export const rememberAcquisitionStore = (store, now = Date.now()) => {
  if (!KNOWN_STORES.includes(store)) return;
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ store, at: now }));
  } catch { /* storage unavailable - store stays unknown */ }
};

/** The remembered store if it is fresh (<24h), else null. Does not clear. */
export const readAcquisitionStore = (now = Date.now()) => {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const { store, at } = JSON.parse(raw);
    if (!KNOWN_STORES.includes(store)) return null;
    if (typeof at !== 'number' || now - at > MAX_AGE_MS) return null;
    return store;
  } catch {
    return null;
  }
};

/** Call after the acquisition doc has been written successfully. */
export const clearAcquisitionStore = () => {
  try { window.localStorage.removeItem(KEY); } catch { /* fine */ }
};
